import React, { useEffect, useState } from "react";
import { Typography, Button, Row, Col, Select, Spin, Table, InputNumber, Tooltip, message, Modal, Form, Input } from 'antd';
import moment from "moment";
// import SidebarLayout from "./SidebarLayout";
import SidebarLayout from "../BankerUI/SidebarLayout";
import _BankAdminService from "../../modules/BankAdminService";
import _NewapplicationService from "../../modules/NewapplicationService";
import FormItemSelect from "../../components/FormItems/FormItemSelect";
import CurrencyInput from "../../components/CurrencyInput";
// import './LiveAccountBalancesForBanker.scss';
import "../BankerUI/LiveAccountBalancesForBanker.scss"
import { SENIOR_PRIVATE_BANKER_ROLE_ID } from "../../constants/DataConstants";
import { COMMON_ERROR_MSG } from "../../constants/constants";
import { SaveOutlined, CloseOutlined, EditOutlined, EyeOutlined, DownloadOutlined,SaveTwoTone, EditTwoTone} from "@ant-design/icons";
import ExcelJS from "exceljs";
import Item from "antd/lib/list/Item";

const { Option } = Select;
const { Title } = Typography;

const LiveAccountBalancesForCompliance = () => {
  const loginEmail = localStorage.getItem("loginEmail");
  //const bankAdminId = localStorage.getItem("BankAdminId");
  const BankerId = localStorage.getItem("BankerId");
  const roleId = Number(localStorage.getItem("RoleId") ?? 0);

  const [selectedSponsor, setSelectedSponsor] = useState(null);
  const [firmList, setFirmList] = useState([]);
  const [selectedFirm, setSelectedFirm] = useState(null);
  const [loanProgramTypeList, setLoanProgramTypeList] = useState([]);
  const [selectedLoanProgramType, setSelectedLoanProgramType] = useState(null);
  const [liveAccountBalanceData, setLiveAccountBalanceData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loanProgrameType, setLoanProgrameType] = useState(null);
  const [lastSubmittedByName, setLastSubmittedByName] = useState(null);
  const [lastSubmittedDate, setLastSubmittedDate] = useState(null);

  const bankadminIdRaw = localStorage.getItem("BankAdminId");
  const BankAdminId = bankadminIdRaw ? parseInt(bankadminIdRaw) : null;
  const [BankAdminID, setBankAdminID] = useState(BankAdminId);

  const bankerRoleId = Number(localStorage.getItem("RoleId") ?? 0);
  const isBanker = bankerRoleId === SENIOR_PRIVATE_BANKER_ROLE_ID;

  const [editingKey, setEditingKey] = useState(null);
  const [editingRow, setEditingRow] = useState({});

  // Subscription Line of Credit/Corporate Loan rows have no ApplicationId -- key off Id instead.
  const getRowEditKey = (record) =>
    (isSubscriptionLine || isCorporateLoan) ? record.Id : record.ApplicationId;

  const isEditing = (record) => getRowEditKey(record) === editingKey;

  const edithandleClick = (record) => {
    setEditingKey(getRowEditKey(record));
    setEditingRow({ ...record });
  };

  const cancelhandleClick = () => {
    setEditingKey(null);
    setEditingRow({});
  };

  const savehandleClick = async (record) => {
    const previousValue =
      record.OutstandingBalanace !== null &&
        record.OutstandingBalanace !== undefined &&
        record.OutstandingBalanace !== "" &&
        Number(record.OutstandingBalanace) !== 0
        ? Number(record.OutstandingBalanace)
        : null;
    const newValue =
      editingRow.OutstandingBalanace !== null &&
        editingRow.OutstandingBalanace !== undefined &&
        editingRow.OutstandingBalanace !== ""
        ? Number(editingRow.OutstandingBalanace)
        : null;

    if (previousValue !== null && newValue !== null && newValue > previousValue) {
      message.error(
        `Current Outstanding Balance cannot be greater than the previous value (${formatCurrency(previousValue)})`
      );
      return;
    }

    if (previousValue === null && newValue !== null) {
      const approvedLoanAmount =
        record.ApprovedLoanAmount !== null &&
          record.ApprovedLoanAmount !== undefined &&
          record.ApprovedLoanAmount !== ""
          ? Number(record.ApprovedLoanAmount)
          : null;

      if (approvedLoanAmount !== null && newValue > approvedLoanAmount) {
        message.error(
          `Current Outstanding Balance cannot be greater than the Approved Loan Amount (${formatCurrency(approvedLoanAmount)})`
        );
        return;
      }
    }

    openCertifyModal(record);
  };

  const performLiveBalanceSave = async () => {
    const record = pendingSaveRecord;
    if (!record) return;

    try {
      setLoading(true);

      const payload = {
        ...record,
        LoanProgrameTypeId: loanProgrameType,
        OutstandingBalanace: editingRow.OutstandingBalanace,
        BankerId: BankerId ? parseInt(BankerId) : null,
        SponserId: selectedSponsor,
        SubmittedByName: submittedByName,
        SubmittedDate: submittedDate,
        // On-screen Corporate Loan rows carry the facility size as "TotalFacilitySize" (LiveAccontModel),
        // but the ApplicantLiveBalance entity/save model stores it as "OriginalFacilitySize" -- map it
        // explicitly so it actually persists. Subscription Line's "TotalCommitment" already matches by
        // name on both sides via the spread above.
        ...(isCorporateLoan ? { OriginalFacilitySize: record.TotalFacilitySize } : {}),
        ...(isSubscriptionLine ? { TotalCommitment: record.TotalCommitment } : {}),
      };

      const res = await _NewapplicationService.addAccountLiveBalanceData(payload);

      if (res?.data?.IsSuccess) {
        setLiveAccountBalanceData((prev) =>
          prev.map((item) =>
            getRowEditKey(item) === getRowEditKey(record)
              ? { ...item, OutstandingBalanace: editingRow.OutstandingBalanace }
              : item
          )
        );
        message.success(res.data.Message || "Record updated successfully");
        setEditingKey(null);
        setEditingRow({});
        closeCertifyModal();
        await getFirmAdminDataForFacility(selectedFirm, loanProgrameType, selectedSponsor);
      } else {
        message.error(res?.data?.Message || COMMON_ERROR_MSG);
      }
    } catch (error) {
      console.error("Update Error:", error);
      message.error("Something went wrong while saving");
    } finally {
      setLoading(false);
    }
  };

  const [certifyModalVisible, setCertifyModalVisible] = useState(false);
  const [pendingSaveRecord, setPendingSaveRecord] = useState(null);
  const [submittedByName, setSubmittedByName] = useState("");
  const [submittedDate, setSubmittedDate] = useState(null);
  const [certifyForm] = Form.useForm();

  const openCertifyModal = (record) => {
    setPendingSaveRecord(record);
    setSubmittedByName("");
    const now = new Date();
    setSubmittedDate(now.toISOString());
    certifyForm.setFieldsValue({
      submittedByName: "",
      submittedDateDisplay: now.toLocaleString(),
    });
    setCertifyModalVisible(true);
  };

  const closeCertifyModal = () => {
    setCertifyModalVisible(false);
    setPendingSaveRecord(null);
    setSubmittedByName("");
    setSubmittedDate(null);
    certifyForm.resetFields();
  };

  const handleCertifyModalSubmit = async () => {
    try {
      await certifyForm.validateFields();
    } catch {
      return;
    }

    performLiveBalanceSave();
  };

  const formatCurrency = (value) => {
    if (value === null || value === undefined || value === "")
      return "-";

    const cleanValue =
      typeof value === "string"
        ? value.replace(/[^0-9.-]+/g, "")
        : value;

    const num = Number(cleanValue);

    return !isNaN(num)
      ? `$${num.toLocaleString("en-US", { minimumFractionDigits: 2 })}`
      : "-";
  };

  const [historyModalVisible, setHistoryModalVisible] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [historyBorrowerName, setHistoryBorrowerName] = useState("");

  const viewhandleClick = async (record) => {
    setHistoryBorrowerName(record.BorrowerName);
    setHistoryModalVisible(true);
    try {
      setHistoryLoading(true);
      const res = (isSubscriptionLine || isCorporateLoan)
        ? await _NewapplicationService.getApplicantLiveBalanceListBySponserIdAndLoanProgrameType(selectedSponsor, loanProgrameType)
        : await _NewapplicationService.getApplicantLiveBalanceListByApplicationId(record.ApplicationId);
      if (res?.data?.IsSuccess && res.data.Obj) {
        const sortedData = [...res.data.Obj].sort(
          (a, b) => (b.IsLatest === true ? 1 : 0) - (a.IsLatest === true ? 1 : 0)
        );
        setHistoryData(sortedData);
      } else {
        setHistoryData([]);
      }
    } catch (error) {
      console.error("Error fetching live balance history:", error);
      message.error(COMMON_ERROR_MSG);
      setHistoryData([]);
    } finally {
      setHistoryLoading(false);
    }
  };

  const closeHistoryModal = () => {
    setHistoryModalVisible(false);
    setHistoryData([]);
    setHistoryBorrowerName("");
  };

  const historyColumns = [
    {
      title: 'Approved Client Name',
      dataIndex: 'ApplicantName',
      key: 'ApplicantName',
      render: (value) => value || historyBorrowerName || "-",
    },
    {
      title: 'Facility Reference',
      dataIndex: 'AccountNumber',
      key: 'AccountNumber',
    },
    {
      title: 'Application Id',
      dataIndex: 'ApplicationId',
      key: 'ApplicationId',
    },
    {
      title: 'Approved Loan Amount',
      dataIndex: 'ApprovedLoanAmount',
      key: 'ApprovedLoanAmount',
      render: (value) =>
        value ? `$${Number(value).toLocaleString("en-US")}` : "-",
    },
    {
      title: 'Current Outstanding Balance',
      dataIndex: 'OutstandingBalanace',
      key: 'OutstandingBalanace',
      render: (value) => formatCurrency(value),
    },
    {
      title: 'Date',
      dataIndex: 'CreatedDate',
      key: 'CreatedDate',
      render: (value) => (value ? moment(value).format("MM/DD/YYYY") : "-"),
    },
  ];

  // History columns for Subscription Line of Credit (LoanProgrameTypeId 2) facilities.
  const subscriptionLineHistoryColumns = [
    { title: 'Borrower Fund', dataIndex: 'BorrowerFund', key: 'BorrowerFund', render: (value) => value || "-" },
    { title: 'Facility', dataIndex: 'Institution', key: 'Institution', render: (value) => value || "-" },
    {
      title: 'Total Commitment', dataIndex: 'TotalCommitment', key: 'TotalCommitment',
      render: (value) => value ? `$${Number(value).toLocaleString("en-US")}` : "-",
    },
    {
      title: 'Borrowing Base', dataIndex: 'BorrowingBase', key: 'BorrowingBase',
      render: (value) => value ? `$${Number(value).toLocaleString("en-US")}` : "-",
    },
    {
      title: 'Outstanding', dataIndex: 'OutstandingBalanace', key: 'OutstandingBalanace',
      render: (value) => formatCurrency(value),
    },
    {
      title: 'Availability', dataIndex: 'Availability', key: 'Availability',
      render: (value) => value ? `$${Number(value).toLocaleString("en-US")}` : "-",
    },
    { title: 'Advance Rate', dataIndex: 'AdvanceRate', key: 'AdvanceRate', render: (value) => value ? `${value}%` : "-" },
    {
      title: 'Date',
      dataIndex: 'CreatedDate',
      key: 'CreatedDate',
      render: (value) => (value ? moment(value).format("MM/DD/YYYY") : "-"),
    },
  ];

  // History columns for Corporate Loan (LoanProgrameTypeId 4) facilities.
  const corporateLoanHistoryColumns = [
    { title: 'Portfolio Company', dataIndex: 'PortfolioCompany', key: 'PortfolioCompany', render: (value) => value || "-" },
    { title: 'Facility', dataIndex: 'Institution', key: 'Institution', render: (value) => value || "-" },
    { title: 'Loan Structure', dataIndex: 'LoanStructure', key: 'LoanStructure', render: (value) => value || "-" },
    {
      title: 'Total Facility Size $', dataIndex: 'OriginalFacilitySize', key: 'OriginalFacilitySize',
      render: (value) => value ? `$${Number(value).toLocaleString("en-US")}` : "-",
    },
    {
      title: 'Current Outstanding Balance', dataIndex: 'OutstandingBalanace', key: 'OutstandingBalanace',
      render: (value) => formatCurrency(value),
    },
    {
      title: 'Availability', dataIndex: 'Availability', key: 'Availability',
      render: (value) => value ? `$${Number(value).toLocaleString("en-US")}` : "-",
    },
    {
      title: 'Maturity Date', dataIndex: 'MaturityDate', key: 'MaturityDate',
      render: (value) => value ? moment(value).format("MM/DD/YYYY") : "-",
    },
    {
      title: 'Date',
      dataIndex: 'CreatedDate',
      key: 'CreatedDate',
      render: (value) => (value ? moment(value).format("MM/DD/YYYY") : "-"),
    },
  ];

  // const getTableEmptyText = () => {
  //   if (Number(loanProgrameType) === 2) {
  //     return <div className="table-empty-message">This is a Subscription Line Facility.</div>;
  //   }
  //   return null;
  // };

  const getTableEmptyText = () => {
    return <div className="table-empty-message">No Data.</div>;
  };

  useEffect(() => {
    if (BankAdminID && BankerId) {
      getFirmList(BankerId, BankAdminID);
    }
  }, [BankAdminID, BankerId]);
  useEffect(() => {
    const handleBankAdminIdChange = (e) => {
      const newId = e.detail.newId;
      setBankAdminID(newId);
    };

    window.addEventListener("BankAdminIdChanged", handleBankAdminIdChange);

    return () => {
      window.removeEventListener("BankAdminIdChanged", handleBankAdminIdChange);
    };
  }, []);

  // Fetch firm list (Choose Credit Facility)
  const getFirmList = async (BankerId, bankAdminId) => {
    try {
      setLoading(true);
      const res = await _BankAdminService.getFirmDropdownListByBankerIdV1(BankerId, roleId, isBanker);

      if (res?.data?.IsSuccess && res.data.Obj) {
        setFirmList(res.data.Obj);
        if (res.data.Obj.length > 0) {
          // auto-select first firm and cascade into its loan programe types
          const firstFirm = res.data.Obj[0];
          setSelectedFirm(firstFirm.Id);
          await getLoanProgramTypeList(firstFirm.Id);
        }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching firm list:", error);
    }
  };

  // Fetch loan programe type list for the selected firm (Choose Loan Programe Type)
  const getLoanProgramTypeList = async (firmId, autoSelect = true) => {
    try {
      setLoading(true);
      const res = await _BankAdminService.getLoanProgrameTypeListByFirmId(firmId, { bankerId: BankerId, roleId, isBanker });

      if (res?.data?.IsSuccess && res.data.Obj) {
        setLoanProgramTypeList(res.data.Obj);
        if (autoSelect && res.data.Obj.length > 0) {
          // auto-select first credit facility and fetch its balances. Each entry is keyed by its
          // own unique SponserId (a firm can have multiple facilities sharing the same
          // LoanProgrameTypeId, differentiated only by Credit Facility Name), so the Select is
          // bound to SponserId while LoanProgrameTypeId is kept separately for type-branching.
          const firstType = res.data.Obj[0];
          setSelectedLoanProgramType(firstType.SponserId);
          setLoanProgrameType(firstType.LoanProgrameTypeId);
          await getFirmAdminDataForFacility(firmId, firstType.LoanProgrameTypeId, firstType.SponserId);
        } else {
          setSelectedLoanProgramType(null);
          setSelectedSponsor(null);
          setLoanProgrameType(null);
          setLiveAccountBalanceData([]);
        }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching loan programe type list:", error);
    }
  };

  // Fetch balances by Firm + Loan Programe Type (resolves to the underlying Sponser record server-side)
  const getFirmAdminDataForFacility = async (firmId, loanProgramTypeId, sponserId) => {
    try {
      setLoading(true);
      const res = await _BankAdminService.getFirmAdminDataByFirmAndLoanProgrameType(firmId, loanProgramTypeId, sponserId);
      if (res?.data?.IsSuccess && res.data.Obj) {
        setLiveAccountBalanceData(res.data.Obj);
        setSelectedSponsor(res.data.Obj[0]?.SponserId ?? null);

        const rowsWithSubmission = res.data.Obj.filter(
          (row) => row.SubmittedByName && row.SubmittedDate
        );
        if (rowsWithSubmission.length > 0) {
          const latest = rowsWithSubmission.reduce((a, b) =>
            new Date(a.SubmittedDate) > new Date(b.SubmittedDate) ? a : b
          );
          setLastSubmittedByName(latest.SubmittedByName);
          setLastSubmittedDate(latest.SubmittedDate);
        } else {
          setLastSubmittedByName(null);
          setLastSubmittedDate(null);
        }
      } else {
        setLiveAccountBalanceData([]);
        setLastSubmittedByName(null);
        setLastSubmittedDate(null);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching firm admin data:", error);
    }
  };

  const handleFirmChange = (value) => {
    setSelectedFirm(value);
    setSelectedLoanProgramType(null);
    setLoanProgramTypeList([]);
    setLiveAccountBalanceData([]);
    setSelectedSponsor(null);
    getLoanProgramTypeList(value, false);
  };

  const handleLoanProgramTypeChange = (value) => {
    // `value` is the selected dropdown entry's SponserId (unique per row); look up its
    // LoanProgrameTypeId from the list to keep type-branching working.
    const matchedFacility = loanProgramTypeList.find((type) => type.SponserId === value);
    setSelectedLoanProgramType(value);
    setLoanProgrameType(matchedFacility?.LoanProgrameTypeId ?? null);
    getFirmAdminDataForFacility(selectedFirm, matchedFacility?.LoanProgrameTypeId, value);
  };



  // Export for Subscription Line of Credit (type 2) / Corporate Loan (type 4) facilities --
  // mirrors the on-screen subscriptionLineColumns/corporateLoanColumns column sets.
  const exportFacilityLevelExcel = async (programData, balances) => {
    const HEADER_FILL = "FF2F6169";
    const SHADED_FILL = "FFD9D9D9";
    const THIN_BORDER = { style: "thin", color: { argb: "FF808080" } };
    const CELL_BORDER = {
      top: THIN_BORDER,
      left: THIN_BORDER,
      bottom: THIN_BORDER,
      right: THIN_BORDER,
    };

    const headerLabels = isSubscriptionLine
      ? ["Borrower Fund", "Institution", "Total Commitment", "Borrowing Base", "Outstanding", "Availability", "Advance Rate"]
      : ["Portfolio Company", "Institution", "Loan Structure", "Total Facility Size $", "Current Outstanding Balance", "Availability", "Maturity Date"];

    const rowValuesFor = (item) =>
      isSubscriptionLine
        ? [
            item.BorrowerFund || "-",
            item.Institution || "-",
            item.TotalCommitment ? `$${Number(item.TotalCommitment).toLocaleString("en-US")}` : "-",
            item.BorrowingBase ? `$${Number(item.BorrowingBase).toLocaleString("en-US")}` : "-",
            formatCurrency(item.OutstandingBalanace),
            item.Availability ? `$${Number(item.Availability).toLocaleString("en-US")}` : "-",
            item.AdvanceRate ? `${item.AdvanceRate}%` : "-",
          ]
        : [
            item.PortfolioCompany || "-",
            item.Institution || "-",
            item.LoanStructure || "-",
            item.OriginalFacilitySize ? `$${Number(item.OriginalFacilitySize).toLocaleString("en-US")}` : "-",
            formatCurrency(item.OutstandingBalanace),
            item.Availability ? `$${Number(item.Availability).toLocaleString("en-US")}` : "-",
            item.MaturityDate ? moment(item.MaturityDate).format("MM/DD/YYYY") : "-",
          ];

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Account Balances");

    worksheet.columns = headerLabels.map(() => ({ width: 20 }));

    worksheet.mergeCells(1, 1, 1, headerLabels.length);
    const titleCell = worksheet.getCell("A1");
    titleCell.value = isSubscriptionLine ? "Account Balances — Subscription Line of Credit" : "Account Balances — Corporate Loan";
    titleCell.font = { bold: true, size: 13 };
    titleCell.alignment = { vertical: "middle" };
    worksheet.getRow(1).height = 22;

    worksheet.getCell("A2").value = "Firm";
    worksheet.getCell("B2").value = programData.Name || "-";
    worksheet.getCell("A3").value = "Institution";
    worksheet.getCell("B3").value = programData.Institution || "-";
    worksheet.getCell("A4").value = "As-of Date";
    worksheet.getCell("B4").value = moment().format("MM/DD/YYYY");
    ["A2", "A3", "A4"].forEach((addr) => {
      worksheet.getCell(addr).font = { bold: true };
    });
    ["B2", "B3", "B4"].forEach((addr) => {
      worksheet.getCell(addr).fill = { type: "pattern", pattern: "solid", fgColor: { argb: SHADED_FILL } };
    });

    const headerRowIndex = 6;
    const headerRow = worksheet.getRow(headerRowIndex);
    headerLabels.forEach((label, idx) => {
      const cell = headerRow.getCell(idx + 1);
      cell.value = label;
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: HEADER_FILL } };
      cell.alignment = { vertical: "middle", horizontal: "left" };
      cell.border = CELL_BORDER;
    });
    headerRow.height = 20;
    headerRow.commit();

    let currentRowIndex = headerRowIndex + 1;
    balances.forEach((item) => {
      const row = worksheet.getRow(currentRowIndex);
      rowValuesFor(item).forEach((val, idx) => {
        const cell = row.getCell(idx + 1);
        cell.value = val;
        cell.border = CELL_BORDER;
        cell.alignment = { horizontal: "left" };
      });
      row.commit();
      currentRowIndex += 1;
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "Levridge_Account_Balances_Export.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  // Export live account balances (by sponsorId) to .xlsx
  const handleDownloadExcel = async () => {
    if (!selectedSponsor) {
      message.warning("Please select a loan program first.");
      return;
    }

    try {
      setLoading(true);
      const res = await _NewapplicationService.getApplicantLiveBalanceBySponserId(selectedSponsor);

      if (!res?.data?.IsSuccess || !res.data.Obj) {
        message.error(res?.data?.Message || COMMON_ERROR_MSG);
        return;
      }

      const programData = res.data.Obj;
      const balances = programData.listApplicantLiveBalances || [];

      if (isSubscriptionLine || isCorporateLoan) {
        await exportFacilityLevelExcel(programData, balances);
        return;
      }

      const HEADER_FILL = "FF2F6169";
      const SHADED_FILL = "FFD9D9D9";
      const TOTAL_FILL = "FFEDEDED";
      const THIN_BORDER = { style: "thin", color: { argb: "FF808080" } };
      const CELL_BORDER = {
        top: THIN_BORDER,
        left: THIN_BORDER,
        bottom: THIN_BORDER,
        right: THIN_BORDER,
      };

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Account Balances");

      worksheet.columns = [
        { width: 24 },
        { width: 20 },
        { width: 16 },
        { width: 12 },
        { width: 18 },
        { width: 14 },
        { width: 14 },
        { width: 22 },
      ];

      // Title
      worksheet.mergeCells("A1:H1");
      const titleCell = worksheet.getCell("A1");
      titleCell.value = "Account Balances — Loan Program";
      titleCell.font = { bold: true, size: 13 };
      titleCell.alignment = { vertical: "middle" };
      worksheet.getRow(1).height = 22;

      // Loan Program / Institution / Program Size / As-of Date summary block
      worksheet.mergeCells("B2:C2");
      worksheet.mergeCells("E2:H2");
      worksheet.mergeCells("B3:C3");
      worksheet.mergeCells("E3:H3");

      worksheet.getCell("A2").value = "Loan Program";
      worksheet.getCell("D2").value = "Institution";
      worksheet.getCell("A3").value = "Program Size";
      worksheet.getCell("D3").value = "As-of Date";
      ["A2", "D2", "A3", "D3"].forEach((addr) => {
        worksheet.getCell(addr).font = { bold: true };
      });

      worksheet.getCell("B2").value = programData.Name || "-";
      worksheet.getCell("E2").value = programData.Institution || "-";
      worksheet.getCell("B3").value = formatCurrency(programData.TotalProgrameSize);
      worksheet.getCell("E3").value = moment().format("MM/DD/YYYY");
      ["B2", "E2", "B3", "E3"].forEach((addr) => {
        worksheet.getCell(addr).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: SHADED_FILL },
        };
      });

      worksheet.getRow(2).height = 18;
      worksheet.getRow(3).height = 18;

      // Table header (row 5, leaving row 4 as a spacer)
      const headerRowIndex = 5;
      const headerLabels = [
        "Approved Client Name",
        "Facility Reference",
        "Application Id",
        "Approved Loan Amount",
        "Current Outstanding Balance",
        "As-of Date",
        "Entered By",
        "Entered On",
      ];
      const headerRow = worksheet.getRow(headerRowIndex);
      headerLabels.forEach((label, idx) => {
        const cell = headerRow.getCell(idx + 1);
        cell.value = label;
        cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: HEADER_FILL } };
        cell.alignment = { vertical: "middle", horizontal: "left" };
        cell.border = CELL_BORDER;
      });
      headerRow.height = 20;
      headerRow.commit();

      // Data rows
      let totalBalance = 0;
      let currentRowIndex = headerRowIndex + 1;

      balances.forEach((item) => {
        totalBalance += Number(item.OutstandingBalanace) || 0;
        const rowDate = item.UpdatedDate || item.CreatedDate;

        const rowValues = [
          item.ApplicantName || "-",
          item.AccountNumber || "-",
          item.ApplicationId || "-",
          item.ApprovedLoanAmount ? `$${Number(item.ApprovedLoanAmount).toLocaleString("en-US")}` : "-",
          formatCurrency(item.OutstandingBalanace) || "-",
          rowDate ? moment(rowDate).format("MM/DD/YYYY") : "-",
          item.EnteredBy || "-",
          item.CreatedDate ? moment(item.CreatedDate).format("MM/DD/YYYY hh:mm:ss A") : "-",
        ];

        const row = worksheet.getRow(currentRowIndex);
        rowValues.forEach((val, idx) => {
          const cell = row.getCell(idx + 1);
          cell.value = val;
          cell.border = CELL_BORDER;
          cell.alignment = { horizontal: "left" };
        });
        row.commit();
        currentRowIndex += 1;
      });

      // Total row
      const totalRow = worksheet.getRow(currentRowIndex);
      const totalValues = ["Total", "", "", "", formatCurrency(totalBalance), "", "", ""];
      totalValues.forEach((val, idx) => {
        const cell = totalRow.getCell(idx + 1);
        cell.value = val;
        cell.border = CELL_BORDER;
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: TOTAL_FILL } };
        cell.font = { bold: true };
      });
      totalRow.commit();

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "Levridge_Account_Balances_Export.xlsx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error exporting live account balances:", error);
      message.error(COMMON_ERROR_MSG);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: 'Approved Client Name',
      dataIndex: 'BorrowerName',
      key: 'BorrowerName',
    },
    {
      title: 'Facility Reference',
      dataIndex: 'AccountNumber',
      key: 'AccountNumber',
    },
    {
      title: 'Application Id',
      dataIndex: 'ApplicationId',
      key: 'ApplicationId',
    },
    {
      title: 'Approved Loan Amount',
      dataIndex: 'ApprovedLoanAmount',
      key: 'ApprovedLoanAmount',
      render: (value) =>
        value ? `$${Number(value).toLocaleString("en-US")}` : "-",
    },
    {
      title: 'Current Outstanding Balance',
      dataIndex: 'OutstandingBalanace',
      key: 'OutstandingBalanace',
      render: (value, record) => {
        const editable = isEditing(record);

        return editable ? (
          <CurrencyInput
            value={editingRow.OutstandingBalanace}
            onChange={(val) =>
              setEditingRow({ ...editingRow, OutstandingBalanace: val })
            }
            style={{ width: "100%" }}
          />
        ) : (
          formatCurrency(value)
        );
      },
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      fixed: "right",
      width: 140,
      render: (_, record) => {
        const editable = isEditing(record);

        return editable ? (
          <div className="actionColumnDiv" style={{ gap: 8 }}>
            <Tooltip title="Save">
              <Button
                type="link"
                onClick={() => savehandleClick(record)}
                icon={<SaveTwoTone />}
              />
            </Tooltip>

            <Tooltip title="Cancel">
              <Button
                type="link"
                onClick={cancelhandleClick}
                icon={<CloseOutlined />}
              />
            </Tooltip>
          </div>
        ) : (
          <div className="actionColumnDiv" style={{ gap: 8 }}>
            <Tooltip title="Edit">
              <Button
                type="link"
                onClick={() => edithandleClick(record)}
                icon={<EditTwoTone />}
              />
            </Tooltip>

            <Tooltip title="View">
              <Button
                type="link"
                onClick={() => viewhandleClick(record)}
                icon={<EyeOutlined />}
              />
            </Tooltip>
          </div>
        );
      },
    },
  ];

  // Shared Action column (Edit/Save/Cancel/View) for the facility-level tables below --
  // mirrors the type 1/3 `columns` Action column exactly.
  const facilityActionColumn = {
    title: "Action",
    key: "action",
    align: "center",
    fixed: "right",
    width: 140,
    render: (_, record) => {
      const editable = isEditing(record);

      return editable ? (
        <div className="actionColumnDiv" style={{ gap: 8 }}>
          <Tooltip title="Save">
            <Button type="link" onClick={() => savehandleClick(record)} icon={<SaveTwoTone />} />
          </Tooltip>
          <Tooltip title="Cancel">
            <Button type="link" onClick={cancelhandleClick} icon={<CloseOutlined />} />
          </Tooltip>
        </div>
      ) : (
        <div className="actionColumnDiv" style={{ gap: 8 }}>
          <Tooltip title="Edit">
            <Button type="link" onClick={() => edithandleClick(record)} icon={<EditTwoTone />} />
          </Tooltip>
          <Tooltip title="View">
            <Button type="link" onClick={() => viewhandleClick(record)} icon={<EyeOutlined />} />
          </Tooltip>
        </div>
      );
    },
  };

  // Subscription Line of Credit (LoanProgrameTypeId 2) -- one row per SponserFund, facility-level fields.
  const subscriptionLineColumns = [
    { title: 'Borrower Fund', dataIndex: 'BorrowerFund', key: 'BorrowerFund', render: (value) => value || "-" },
    { title: 'Facility', dataIndex: 'Institution', key: 'Institution', render: (value) => value || "-" },
    {
      title: 'Total Commitment', dataIndex: 'TotalCommitment', key: 'TotalCommitment',
      render: (value) => value ? `$${Number(value).toLocaleString("en-US")}` : "-",
    },
    {
      title: 'Borrowing Base', dataIndex: 'BorrowingBase', key: 'BorrowingBase',
      render: (value) => value ? `$${Number(value).toLocaleString("en-US")}` : "-",
    },
    {
      title: 'Outstanding', dataIndex: 'OutstandingBalanace', key: 'OutstandingBalanace',
      render: (value, record) => {
        const editable = isEditing(record);
        return editable ? (
          <CurrencyInput
            value={editingRow.OutstandingBalanace}
            onChange={(val) => setEditingRow({ ...editingRow, OutstandingBalanace: val })}
            style={{ width: "100%" }}
          />
        ) : (
          formatCurrency(value)
        );
      },
    },
    {
      title: 'Availability', dataIndex: 'Availability', key: 'Availability',
      render: (value) => value ? `$${Number(value).toLocaleString("en-US")}` : "-",
    },
    { title: 'Advance Rate', dataIndex: 'AdvanceRate', key: 'AdvanceRate', render: (value) => value ? `${value}%` : "-" },
    facilityActionColumn,
  ];

  // Corporate Loan (LoanProgrameTypeId 4) -- single facility-level row.
  const corporateLoanColumns = [
    { title: 'Portfolio Company', dataIndex: 'PortfolioCompany', key: 'PortfolioCompany', render: (value) => value || "-" },
    { title: 'Facility', dataIndex: 'Institution', key: 'Institution', render: (value) => value || "-" },
    { title: 'Loan Structure', dataIndex: 'LoanStructure', key: 'LoanStructure', render: (value) => value || "-" },
    {
      title: 'Total Facility Size $', dataIndex: 'TotalFacilitySize', key: 'TotalFacilitySize',
      render: (value) => value ? `$${Number(value).toLocaleString("en-US")}` : "-",
    },
    {
      title: 'Current Outstanding Balance', dataIndex: 'OutstandingBalanace', key: 'OutstandingBalanace',
      render: (value, record) => {
        const editable = isEditing(record);
        return editable ? (
          <CurrencyInput
            value={editingRow.OutstandingBalanace}
            onChange={(val) => setEditingRow({ ...editingRow, OutstandingBalanace: val })}
            style={{ width: "100%" }}
          />
        ) : (
          formatCurrency(value)
        );
      },
    },
    {
      title: 'Availability', dataIndex: 'Availability', key: 'Availability',
      render: (value) => value ? `$${Number(value).toLocaleString("en-US")}` : "-",
    },
    {
      title: 'Maturity Date', dataIndex: 'MaturityDate', key: 'MaturityDate',
      render: (value) => value ? moment(value).format("MM/DD/YYYY") : "-",
    },
    facilityActionColumn,
  ];

  const isSubscriptionLine = Number(loanProgrameType) === 2;
  const isCorporateLoan = Number(loanProgrameType) === 4;
  const activeColumns = isSubscriptionLine ? subscriptionLineColumns : isCorporateLoan ? corporateLoanColumns : columns;
  const activeRowKey = isSubscriptionLine || isCorporateLoan ? "Id" : "AccountNumber";
  const activeHistoryColumns = isSubscriptionLine
    ? subscriptionLineHistoryColumns
    : isCorporateLoan
    ? corporateLoanHistoryColumns
    : historyColumns;

  return (
    <Spin spinning={loading}>
      <SidebarLayout>
        <div className="live-account-balances-container">
          <Title level={3} className="page-title">
           Account Balances
          </Title>
          <Title level={5} className="page-sub-title">
            View balances for approved borrowers under the selected credit facilities.
          </Title>

          <div className="card-section choose-loan-program-section inputDisabledBlackColor">
            <label className="choose-loan-program-label">Select Firm : </label>
            <Select
              placeholder="Select Firm"
              value={selectedFirm}
              onChange={handleFirmChange}
              popupClassName="loan-program-dropdown"
            >
              {firmList.map((firm) => (
                <Option key={firm.Id} value={firm.Id}>
                  {firm.FirmName}
                </Option>
              ))}
            </Select>

            <label className="choose-loan-program-label">Select Credit Facility : </label>
            <Select
              placeholder="Select Credit Facility Type"
              value={selectedLoanProgramType}
              onChange={handleLoanProgramTypeChange}
              popupClassName="loan-program-dropdown"
            >
              {loanProgramTypeList.map((type) => (
                <Option key={type.SponserId} value={type.SponserId}>
                  {type.Name}
                </Option>
              ))}
            </Select>

            {lastSubmittedByName && lastSubmittedDate && (
              <div style={{ marginLeft: "auto", display: "flex", flexDirection: "column", gap: 4, color: "#f4f4f5b2" }}>
                <span>
                  <strong style={{ color: "#f4f4f5" }}>Submitted By :</strong> {lastSubmittedByName}
                </span>
                <span>
                  <strong style={{ color: "#f4f4f5" }}>Date &amp; Time :</strong>{" "}
                  {moment.utc(lastSubmittedDate).local().format("MM/DD/YYYY hh:mm A")}
                </span>
              </div>
            )}
          </div>

          {/* Account Balance Table */}
          <Table
            dataSource={liveAccountBalanceData}
            columns={activeColumns}
            rowKey={activeRowKey}
            pagination={false}
            className="transparent-table"
            locale={{ emptyText: getTableEmptyText() }}
            scroll={{ x: "max-content" }}
          />

          <Modal
            title="Live Account Balances Transaction History"
            open={historyModalVisible}
            onCancel={closeHistoryModal}
            footer={null}
            width={900}
            destroyOnClose
          >
            <Spin spinning={historyLoading}>
              <Table
                dataSource={historyData}
                columns={activeHistoryColumns}
                rowKey="Id"
                pagination={false}
                className="transparent-table"
              />
            </Spin>
          </Modal>

          <Modal
            title="Certify & Submit"
            open={certifyModalVisible}
            onCancel={closeCertifyModal}
            footer={null}
            width={600}
            destroyOnClose
          >
            <div style={{ color: "#f4f4f5" }}>
              I, <b>{submittedByName.trim() || "[Name]"}</b>, hereby certify that I am authorized
              to update this account balance. I confirm the updated balance is accurate as of the
              date and time below and is supported by verified documentation on file. I understand
              this update is recorded and subject to audit.
            </div>
            <Form form={certifyForm} layout="vertical">
              <Row gutter={16} style={{ marginTop: 16 }}>
                <Col xs={24} sm={12}>
                  <Form.Item
                    label="Name"
                    name="submittedByName"
                    rules={[{ required: true, message: "Name is required" }]}
                  >
                    <Input
                      placeholder="Enter your name"
                      onChange={(e) => setSubmittedByName(e.target.value)}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item label="Date & Time" name="submittedDateDisplay">
                    <Input disabled />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 24 }}>
              <Button onClick={closeCertifyModal}>Cancel</Button>
              <Button type="primary" loading={loading} onClick={handleCertifyModalSubmit}>
                Submit
              </Button>
            </div>
          </Modal>
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 20 }}>
          <Button
            type="primary"
            icon={<DownloadOutlined />}
            onClick={handleDownloadExcel}
            disabled={!selectedSponsor}
          >
            Export Excel
          </Button>
        </div>
      </SidebarLayout>
    </Spin>
  );
};

export default LiveAccountBalancesForCompliance;